module.exports = __webpack_public_path__ + "img/9_54.1b6adca6.png";